import toast from "react-hot-toast";
import {
    CreateCustomersNotificationsMethodURL,
    fetch_instance,
    getAccessToken,
    getCustomerNotificationsApiMethodUrl,
    getNotificationListMethodURL,
    getOrderAlertListMethodURL,
    getRepeatedOrdersListMethodURL,
    GetSystemNotificationsMethodURL,
    MarkAllAsReadApiMethodUrl,
    MarkAllRepeatedOrderAsReadApiMethodUrl,
    MarkAllSystemNotificationAsReadApiMethodUrl,
    MarkAsReadApiMethodUrl,
    MarkCustomerAllAsReadApiMethodUrl,
    MarkCustomerAsReadApiMethodUrl,
    ServerURL,
    UserNotificationPermissionApiMethodUrl,
} from "./ServerConfig";

class notifications_api {
  async get_user_permission(user_id = 0) {
    let obj = [];
    await fetch_instance(
      `${ServerURL}${UserNotificationPermissionApiMethodUrl}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        body: JSON.stringify({
          user: user_id,
        }),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // console.log(data)
        obj = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        toast.error(error.toString());
        console.log(error);
      });
    return Promise.resolve(obj);
  }
  async save_user_permission(permissions = []) {
    let response;

    await fetch_instance(
      `${ServerURL}${UserNotificationPermissionApiMethodUrl}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        body: JSON.stringify({
          permissions: permissions || [],
        }),
      }
    )
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }

    async get_notifications(user_id = 0, system_notifications = true) {
        try {
            const api_method_name = system_notifications
                ? GetSystemNotificationsMethodURL
                : getNotificationListMethodURL;

            const response = await fetch_instance(
                `${ServerURL}${api_method_name}?id=${user_id}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${getAccessToken()}`,
                    },
                }
            );

            const data = await response.json();

            // System notifications return:
            // { count: number, results: [] }
            if (data.results) {
                return data.results;
            }

            // Normal notifications may return [] directly
            if (Array.isArray(data)) {
                return data;
            }

            return [];
        } catch (error) {
            const err = error.toString();

            if (err.includes("Failed to fetch") || err.includes("NetworkError")) {
                toast.error("Network error. Please reload and try again.");
            } else {
                toast.error(err);
            }

            console.error(error);
            return [];
        }
    }



  async get_order_alerts(user_id = 0) {
    let obj = [];
    await fetch_instance(
      `${ServerURL}${getOrderAlertListMethodURL}?id=${user_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // console.log('notifications data')
        // // console.log(data)
        if (data.length) {
          obj = data;
        }

        // return Promise.resolve(obj)
      })
      .catch((error) => {
        toast.error(error.toString());
        console.log(error);
      });
    return Promise.resolve(obj);
  }

  async getRepeatedOrdersList(user_id = 0) {
    let obj = [];
    await fetch_instance(
      `${ServerURL}${getRepeatedOrdersListMethodURL}?id=${user_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.length) {
          obj = data;
        }
      })
      .catch((error) => {
        toast.error(error.toString());
        console.log(error);
      });
    return Promise.resolve(obj);
  }
  async mark_as_read(user_id = 0, notifications = []) {
    let response;

    await fetch_instance(`${ServerURL}${MarkAsReadApiMethodUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify({
        for_user: parseInt(user_id, 10),
        notifications: notifications || [],
      }),
    })
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }

  async mark_all_as_read(user_id = 0, system_notifications = false) {
       try {
          const api_method_name = system_notifications
              ? MarkAllSystemNotificationAsReadApiMethodUrl
              : MarkAllAsReadApiMethodUrl;

          const options = {
              method: "POST",
              headers: {
                  Authorization: `Bearer ${getAccessToken()}`,
                  "Content-Type": "application/json",
              },
          };

          // normal notifications require user_id
          if (!system_notifications) {
              options.body = JSON.stringify({for_user: user_id});
          }

          return await fetch_instance(`${ServerURL}${api_method_name}`, options);

       } catch (error) {
          console.error(error);
          toast.error("Failed to mark notifications as read");
          return null;
       }
  }

  async mark_allRepeatedOrder_as_read(user_id = 0) {
    let response;
    await fetch_instance(
      `${ServerURL}${MarkAllRepeatedOrderAsReadApiMethodUrl}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        body: JSON.stringify({
          for_user: user_id,
        }),
      }
    )
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }

  //   async mark_all_as_read(user_id=0){
  //     let response ;
  //    await fetch_instance(`${ServerURL}${MarkAllAsReadApiMethodUrl}`,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Authorization':`Bearer ${getAccessToken()}`
  //       }
  //       , body :JSON.stringify({
  //           'for_user' : user_id
  //       })
  //     })
  //     .then((response) => {
  //       return response ;
  //     })
  //     .then((data) => {
  //         response = data
  //         // return Promise.resolve(obj)

  //     })
  //     .catch((error)=>{
  //       // toast.error(error.toString());

  //     });
  //     return Promise.resolve(response)
  // }

  // Customer Notifications

  async mark_customer_as_read(id) {
    let response;

    await fetch_instance(`${ServerURL}${MarkCustomerAsReadApiMethodUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        id,
      }),
    })
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }
  async mark_all_customer_as_read() {
    let response;
    await fetch_instance(`${ServerURL}${MarkCustomerAllAsReadApiMethodUrl}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    })
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }

  async create_customer_notifications(body) {
    let response;
    await fetch_instance(
      `${ServerURL}${CreateCustomersNotificationsMethodURL}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => {
        return response;
      })
      .then((data) => {
        response = data;
        // return Promise.resolve(obj)
      })
      .catch((error) => {
        // toast.error(error.toString());
      });
    return Promise.resolve(response);
  }

  async sendCustomerWhatsApp(body) {
    try {
      const response = await fetch_instance(
          `${ServerURL}notification/send_whatsapp_message_to_customers`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
              // "Content-Type": "application/json",
            },
            body: body,
            // body: JSON.stringify(body),
          }
      );

      const data = await response.json();

      if (!response.ok) {
        const errorMessage =
            data?.message || data?.detail || "Unexpected error occurred";
        throw new Error(errorMessage);
      }

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async previewCustomerWhatsApp(body) {
    const response = await fetch_instance(
      `${ServerURL}notification/customer-whatsapp/preview`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        body,
      }
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data?.message || data?.detail || "Unexpected error occurred");
    return data;
  }

  async getCustomerWhatsAppPreviewDetails(body) {
    const response = await fetch_instance(
      `${ServerURL}notification/customer-whatsapp/preview-details`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${getAccessToken()}` },
        body,
      }
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data?.message || data?.detail || "Unexpected error occurred");
    return data;
  }

  async create_whatsapp_customer_notifications(body) {
    return this.sendCustomerWhatsApp(body);
  }

  async get_customer_notifications() {
    let obj = {};
    await fetch_instance(
      `${ServerURL}${getCustomerNotificationsApiMethodUrl}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
          obj = data;

        return Promise.resolve(obj)
      })
      .catch((error) => {
        let err = error.toString();
        if (err.includes("Failed to fetch") || err.includes("NetworkError")) {
          // if (err == "TypeError: Failed to fetch" || err == "TypeError: NetworkError when attempting to fetch resource.") {
          toast.error(`Something went wrong Please Reload and try again`);
        }
        toast.error(error.toString());
        console.log(error);
      });
    return Promise.resolve(obj);
  }
}
export const NotificationsApi = new notifications_api();
